<template>
    <div class="flex flex-col inset-0 h-full">
        <conversation-nav class="justify-between">
            <div class="flex gap-2 items-center">
                <vx-button
                    size="sm"
                    color="secondary"
                    @click="emit('close')"
                    data-test="back-to-conversation"
                    aria-label="Back to conversation"
                >
                    <font-awesome-icon widthAuto :icon="faArrowLeft"></font-awesome-icon>
                </vx-button>
                <span class="text-base text-slate-100 font-extrabold self-center">Edit Contact</span>
            </div>
            <vx-button size="sm" color="secondary" :href="`/contacts/${contact.id}`" target="_blank">
                Open in Voxie
                <font-awesome-icon widthAuto :icon="faSquareArrowUpRight"></font-awesome-icon>
            </vx-button>
        </conversation-nav>
        <div class="flex flex-col gap-2 grow p-4 overflow-y-auto">
            <vx-expandable-card class="mx-auto lg:max-w-(--breakpoint-sm)">
                <template v-slot:content>
                    <div class="font-semibold text-base mb-1 flex items-center justify-between">Name:</div>
                    <div class="flex flex-col gap-4 items-start">
                        <span class="text-2xl text-slate-500">{{ fullName }}</span>
                        <vx-button color="muted" size="md" block @click="editContactModal = true">Edit</vx-button>
                    </div>
                    <contact-edit-modal v-model="editContactModal"></contact-edit-modal>
                </template>
            </vx-expandable-card>
            <contact-view
                :contactId="contact.id"
                :allowEditContact="false"
                :editableRelationships="true"
                class="mx-auto"
                @currentGroupRemoved="emit('currentGroupRemoved')"
            ></contact-view>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';
import { faSquareArrowUpRight, faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ConversationNav from '~/components/messages/browser-extension/components/ConversationNav.vue';
import ContactEditModal from '~/components/messages/browser-extension/components/misc/ContactEditModal.vue';

import ContactView from '~/components/contacts/contact/ContactView.vue';
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';

const emit = defineEmits(['close', 'currentGroupRemoved']);

const { fullName, contact } = useContactDetails();

const editContactModal = ref(false);
</script>
